import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import EditCompanyGroupForm from './EditCompanyGroupForm';

const EditCompanyModal = ({ isOpen, onConfirm, onCancel }) => {
  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>Edit Company Group</ModalHeader>
      <ModalBody>
        <EditCompanyGroupForm />
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button color="primary" onClick={onConfirm}>
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditCompanyModal;
